// src/Components/Invigilation/Presets/defaultPresets.ts

// Define the shape of a preset setting (copied from usePresets.ts for clarity)
interface PresetSetting {
    contrast: boolean;
    showSettingsPanel: boolean;
    arrangements: boolean;
    startZoomFactor: number;
    zoom: number;
    detailZoom: number;
    clockZoom: number;
    startClockZoom: number;
    titleZoom: number;
    subheaderZoom: number;
    timeZoom: number;
    chipZoom: number;
    reminderZoom: number;
    notesZoom: number;
    supervisionZoom: number;
    showNotes: boolean;
    showSupervision: boolean;
    viewMode: 'columns' | 'rows' | 'grid';
    numColumns: number;
    themeMode: 'light' | 'dark';
    showStartTime: boolean;
    showCurrentTime: boolean;
    showCountdown: boolean;
    showEndings: boolean;
    showSeconds: boolean;
    use24HourTime: boolean;
    showQualification: boolean;
    showLevel: boolean;
    showFiveMins: boolean;
    showThirtyMins: boolean;
    useSound: boolean;
    showDividers: boolean;
    showGranularZoomControls: boolean;
    showPauseControls: boolean;
    showExtraTimeControls: boolean;
    showPaper: boolean;
    showDuration: boolean;
}

// Define the shape of a preset object stub (without ID)
export interface PresetStub { // Add export keyword
    name: string;
    settings: Partial<PresetSetting>;
}

export const defaultPresetsData: PresetStub[] = [
    {
        name: "Default View",
        settings: {
            contrast: false,
            showSettingsPanel: false,
            arrangements: false,
            startZoomFactor: 1,
            zoom: 1,
            detailZoom: 1.5,
            clockZoom: 2,
            startClockZoom: 2,
            titleZoom: 1,
            subheaderZoom: 0.8,
            timeZoom: 1,
            chipZoom: 0.5,
            reminderZoom: 1,
            notesZoom: 1,
            supervisionZoom: 1,
            showNotes: true,
            showSupervision: true,
            viewMode: 'columns',
            numColumns: 2,
            themeMode: 'light',
            showStartTime: true,
            showCurrentTime: true,
            showCountdown: true,
            showEndings: true,
            showSeconds: true,
            use24HourTime: false,
            showQualification: true,
            showLevel: true,
            showFiveMins: true,
            showThirtyMins: true,
            useSound: false,
            showDividers: true,
            showGranularZoomControls: true,
            showPauseControls: true,
            showExtraTimeControls: true,
            showPaper: true,
            showDuration: true,
        }
    },
    // JCQ
    {
        name: "JCQ",
        settings: {
            contrast: false,
            showSettingsPanel: false,
            arrangements: false,
            startZoomFactor: 1,
            zoom: 1,
            detailZoom: 2,
            clockZoom: 5,
            startClockZoom: 3,
            titleZoom: 2,
            subheaderZoom: 2,
            timeZoom: 3,
            chipZoom: 0.6,
            reminderZoom: 1,
            notesZoom: 1,
            supervisionZoom: 1,
            showNotes: false,
            showSupervision: false,
            viewMode: 'grid',
            numColumns: 2,
            themeMode: 'light',
            showPaper: true,
            showDuration: true,
            showStartTime: true,
            showCurrentTime: true,
            showCountdown: false,
            showEndings: true,
            showSeconds: true,
            use24HourTime: false,
            showQualification: true,
            showLevel: true,
            showFiveMins: false,
            showThirtyMins: false,
            useSound: false,
            showDividers: true,
            showGranularZoomControls: true,
            showPauseControls: true,
            showExtraTimeControls: true,
        }
    }
];
